import { Icon } from 'gu-ui-kit'
import React from 'react'
import format from 'utils/dateFns/format'
import { subWeeks } from 'date-fns'

const now = new Date()
const startDate = subWeeks(now, 2)

export default () => {
  return {
    initial: {
      query: '',
      status: [],
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(now, 'yyyy-MM-dd'),
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'services::account_list.query_label',
        placeholder:
          'services::account_list.filter_controls.filter_input.placeholder',
        order: 1,
        type: 'input',
      },
      status: {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'secondary-33'}
            color={'basic-primary-white'}
          />
        ),
        label: 'services::account_list.status_label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'services::transfers_list.status.',
        options: ['pending', 'paused', 'success', 'cancelled', 'declined'],
      },
      datepicker: {
        names: ['date_from', 'date_to'],
        subbutton: {
          // eslint-disable-next-line no-unused-vars
          isVisible: (value = [], breakpoints) => !!breakpoints.sm,
        },
        // @todo нужен общий лейбл а не в пульсе
        label: 'pulse::filters.range.label',
        order: 2,
        type: 'datepicker',
      },
    },
  }
}
